export const ENABLE_OPEN_API = false;
export const ENABLE_FILTERS_IN_SEARCH_PARAMS = true;
export const DISABLE_DOWNLOADS = false;
export const ENABLE_WTWN_BY_UNIT_DESCRIPTION_FEATURE = true;
export const ENABLE_PRIOR_KNOWLEDGE_REQUIREMENTS = true;
export const ENABLE_NC_XLSX_DOCUMENT = true;
